<div class="rs-panel-big rs-bg-c2 clearfix">
  <h2 class="rs-tit3">{{ 'publicWifi.pxsplus.hotspot.subtitle' | translate }}</h2>
  <p>{{ 'publicWifi.pxsplus.hotspot.paragraph1' | translate }}</p>
  <p>{{ 'publicWifi.pxsplus.hotspot.paragraph2' | translate }}</p>
  <div class="rs-me"></div>
  <a
    href="javascript:void(0)"
    class="rs-btn"
    *ngIf="configureUrl"
    (click)="sendConfigureUrl(); $event.stopPropagation()"
    >{{ 'publicWifi.pxsplus.hotspot.configure' | translate }}
  </a>

  <a
    href="javascript:void(0)"
    *ngIf="!configureUrl"
    class="rs-btn rs-btn-waiting"
    [ngClass]="negativeButtonClass"
  >
    <div class="rs-btn-waiting-dots"></div>
    &nbsp;
  </a>
</div>
